<div class="parent" fxFlex="100">
  <div class="row">
    <span><mat-icon class="error-icon icon-xl">error</mat-icon></span>
  </div>
  <div class="row">
    <h1>{{ 'ANR-AgreementNotReady' | translate }}</h1>
  </div>
  <div class="row">
    <h3>{{ 'ANR-AdditionalInfo' | translate }}</h3>
  </div>
  <div class="row top-margin">
    <a [routerLink]="['/profile', workerId]">{{ 'SAW-SeeWorkerProfile' | translate }}</a>
  </div>
</div>
